module.exports = __webpack_public_path__ + "img/products_big_can_extra_ru.b760ccff.png";